/** Depth class a sample was drawn from. */
export type Depth = "Surface" | "Middle" | "Bottom";

export const DEPTHS: Depth[] = ["Surface", "Middle", "Bottom"];

export const DEPTH_COLOR: Record<Depth, string> = {
  Surface: "#0E6CA8",
  Middle: "#1A7A3C",
  Bottom: "#C99700",
};

export interface Station {
  id: string;
  siteId: string;
  key: string;
  ambiguousId: boolean;
  name: string;
  waterbody: string;
  description: string | null;
  lat: number;
  lng: number;
  imageUrl: string | null;
  thumbUrl: string | null;
  samples: number;
  firstYear: number | null;
  lastYear: number | null;
  /** Most recent value per parameter key, preferring a surface sample.
   *  `d` is the depth class the value actually came from. */
  latest: Record<string, { v: number; y: number; d: Depth } | undefined>;
}

/** Compact wire format. s=station key, y=year, d=date, c=depth class,
 *  v=parameter values by key, nulls omitted. */
export interface SampleRow {
  s: string;
  y: number;
  d: string;
  c: Depth;
  v: Record<string, number>;
}

export interface Payload {
  generatedAt: string;
  mapboxToken: string;
  stations: Station[];
  samples: SampleRow[];
  waterbodies: { value: string; n: number }[];
  /** How many samples carry each parameter, so the UI can order and annotate
   *  the selector rather than offering mostly-empty parameters as equals. */
  coverage: Record<string, number>;
  rowsExcluded: number;
  duplicateIds: string[];
}
